import { CommonGraph, GenericGraphProcessType } from '@common/types';
import { StableChildren } from '@prophecy/utils/react/StableChildren';
import { createContext, MutableRefObject } from 'react';

import { WorkflowGraph, WorkflowState } from '../../../redux/types';
import { DatasetEntityType, NewDatasetConfig } from '../config';

export const MockWorkflowContext = createContext<MockWorkflowContextType>({
  callbackRef: {
    current: {
      getWorkflowStore: () => ({}),
      createGem: () => Promise.resolve({}),
      openDialog: (_processId: string) => {},
      updateCurrentDataset: (_dataset: NewDatasetConfig) => {},
      handleDatasetConfig: (_dataset: DatasetEntityType) => Promise.resolve(),
      disableConfigButton: () => {}
    }
  },
  currentDatasetRef: { current: null },
  handledatasetConfigOnMountRef: { current: true },
  wipStateRef: { current: null }
});

export type Process = GenericGraphProcessType<CommonGraph>;

export interface MockWorkflowContextType {
  callbackRef: React.MutableRefObject<{
    getWorkflowStore: () => WorkflowState | {};
    createGem: (dataset: DatasetEntityType) => Promise<Partial<Process>>;
    openDialog: (processId: string) => void;
    updateCurrentDataset: (dataset: NewDatasetConfig) => void;
    handleDatasetConfig: (dataset: DatasetEntityType) => Promise<void>;
    disableConfigButton: (disable: boolean) => void;
  }>;
  currentDatasetRef: MutableRefObject<DatasetEntityType | null>;
  handledatasetConfigOnMountRef: MutableRefObject<boolean>;
  wipStateRef: MutableRefObject<GenericGraphProcessType<WorkflowGraph> | null>;
}

export const MockWorkflowProvider = ({
  value,
  children
}: {
  value: MockWorkflowContextType;
  children: React.ReactNode;
}) => {
  return (
    <MockWorkflowContext.Provider value={value}>
      <StableChildren>{children}</StableChildren>
    </MockWorkflowContext.Provider>
  );
};
